<template>
    <div>
        投注站众筹招股
        <el-form ref="form"
                 :model="form"
                 label-width="180px">
            <el-form-item label="标题">
                <el-input placeholder="投注站(或站长用户名)+彩种+期号"></el-input>
            </el-form-item>
            <el-form-item label="关联实战团队方案">
                <el-input value="2022123期翱翔团队123注"></el-input>
            </el-form-item>
            <el-form-item label="众筹彩种">
                <el-select v-model="model"
                           placeholder="">
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出票站号">
                <el-input placeholder="123"></el-input>
            </el-form-item>
            <el-form-item label="出票站点">
                <el-input placeholder="地址和站号"></el-input>
            </el-form-item>
            <el-form-item label="截至时间">
                <el-input placeholder="某年某月某日,某时某分(一般是停售前2个小时)"></el-input>
            </el-form-item>
            <el-form-item label="众筹总额">
                <el-input placeholder="单行输入"></el-input>
            </el-form-item>
            <el-form-item label="众筹定额股数">
                <el-input placeholder="123"></el-input>
            </el-form-item>
            <el-form-item label="每股价格">
                <el-input placeholder="123"></el-input>
            </el-form-item>
            <el-form-item label="众筹说明">
                <el-input type="textarea"
                          placeholder="多行输入"></el-input>
            </el-form-item>
            <el-form-item label="实战详情">
                <el-input type="textarea"
                          placeholder="开奖当天停售前自动显示,停售后自动显示"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary">确定发布</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data () {
        return {
            model: '双色球',
            options: [
                { label: '双色球', value: 1 },
                { label: '大乐透', value: 2 },
                { label: '福彩3D', value: 3 },
                { label: '排列三', value: 4 },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
</style>